import styled from 'styled-components'
import { GRAYSCALE_500 } from '../../styles/colors'
import { INTER } from '../../styles/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const KeyText = styled.span`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.light};
  max-width: 50%;
`
